export default "__VITE_ASSET__CFRGlNTK__"